import styles from "../Components/ProductList.module.css";
import axios from "axios";
import { useEffect, useState } from "react";
import Api from "../Components/Api";
// const stateCityData = {
//   'HR': ['Faridabad'],
//   'BR': ['Gaya', 'Patna', 'Jehanabad'],
//   'DL': ['New Delhi'],
// };
const SignUp = () => {  
  const [mobileno, setMobileno] = useState('');
  const [password, setPassword] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [emailid, setEmailid] = useState('');  
  const [address, setAddress] = useState('');
  const [selectedState, setSelectedState] = useState();
  const [state,setState] = useState([]);
  const [city, setCity] = useState();
  const [cities, setCities] = useState([]);
  const [pincode,setPincode] = useState('');
//all-districts/
  useEffect(()=>{
    const states = async () => {
            try {
                const state = await Api.get(`/all-states`);
                //console.log(state.data)
                setState(state.data)                           
                
            } catch (error) {
                console.log(`Hello ${error}`);
            }
        }
        states();    
  },[])

  const handleStateChange = (e) => {    
    const stateName = e.target.value;
    setSelectedState(stateName);
    Api.get(`/all-districts/${stateName}`).then((response) => {
                     //console.log(response.data)  
                     setCities(response.data || [])                   
                 })
    //setCities(stateCityData[stateName] || [])

  }
  //create here for submit method
    const submit = async (e) => { 
        console.log('Hello');
    e.preventDefault();
    const user = {
      mobileno: mobileno,
      password:password,
      firstname: firstname,
      lastname: lastname,
      emailid: emailid,
      address: address,
      state : selectedState,
      city: city,
      pincode: pincode,
    };
    //create her post request
    //const { data } = await
      //axios.post(`${global.config.live_url}/api/register/`, user,{mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, withCredentials: true });
      Api.post(`/register/`, user,{mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, withCredentials: true });
      
    window.location.href = '/';
   
  }
    return (
      <>
        <div className={`col-sm-12 ${styles.mainContainer}`}>
          <div className="container-fluid">
            <form onSubmit={submit}>
              <div className="mb-3 row">
                <label for="inputMobileNo" className="col-sm-2 col-form-label">
                  Mobile no
                </label>
                <div className="col-sm-10">
                  <input
                    type="number"
                    className="form-control"
                    id="inputMobileNo"
                    required
                    value={mobileno}
                    onChange={(e) => setMobileno(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label for="inputPassword" className="col-sm-2 col-form-label">
                  Password
                </label>
                <div className="col-sm-10">
                  <input
                    type="password"
                    className="form-control"
                    id="inputPassword"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label for="inputFirstName" className="col-sm-2 col-form-label">
                  First Name
                </label>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    id="inputFirstName"
                    required
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label for="inputLastName" className="col-sm-2 col-form-label">
                  Last Name
                </label>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    id="inputLastName"
                    required
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label for="inputEmailId" className="col-sm-2 col-form-label">
                  Email ID
                </label>
                <div className="col-sm-10">
                  <input
                    type="email"
                    className="form-control"
                    id="inputEmailId"                    
                    value={emailid}
                    onChange={(e) => setEmailid(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
              <label for="addressTextarea1" className="col-sm-2 col-form-label">Address</label>
              <div className="col-sm-10">
                <textarea className="form-control" id="addressTextarea1" rows="3" required
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}></textarea>
              </div>
              </div>
              <div className="mb-3 row">
                <label for="selectStateId" className="col-sm-2 col-form-label">
                  State
                </label>
                <div className="col-sm-10">
                  <select className="form-control" id="selectStateId" required onChange={handleStateChange}>
                    <option value="0">select State</option>
                    {state.map((item)=>{
                      return <option value={item.id}>{item.state_name}</option> 
                    })}
                                                       
                  </select>
                </div>
              </div>
              <div className="mb-3 row">
                <label for="selectCityId" className="col-sm-2 col-form-label">
                  City/Town
                </label>
                <div className="col-sm-10">
                  <select className="form-control" id="selectCityId" required onChange={(e) => setCity(e.target.value)}>
                    <option value="">select city/town</option>
                    {cities.map((item)=>{                      
                      return <option value={item.town_name} key={item.town_name}>{item.town_name}</option>
                    })}                                        
                  </select>
                </div>
              </div>
              <div className="mb-3 row">
                <label for="inputPinCodeId" className="col-sm-2 col-form-label">
                  Pin Code
                </label>
                <div className="col-sm-10">
                  <input
                    type="number"
                    className="form-control"
                    id="inputPinCodeId"                    
                    maxlength="6"
                    required
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                  />
                </div>
              </div>

              <div className="mb-3 row">
                <label
                  for="textareaAddress"
                  className="col-sm-2 col-form-label"
                ></label>
                <div className="col-sm-10">
                  <button type="submit" className="btn btn-info">
                    Sign Up
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </>
    );    
}
export default SignUp